import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";

// Importing altcha package will introduce a new element <altcha-widget>
import "altcha";
import config from "src/config/config";

interface AltchaProps {
    onStateChange?: (ev: Event | CustomEvent) => void;
    onVerified: (ev: CustomEvent) => void;
}

const Altcha = forwardRef<{ value: string | null }, AltchaProps>(({ onStateChange, onVerified }, ref) => {
    const widgetRef = useRef<AltchaWidget & AltchaWidgetMethods & HTMLElement>(null);
    const [value, setValue] = useState<string | null>(null);

    useImperativeHandle(ref, () => {
        return {
            get value() {
                return value;
            },
        };
    }, [value]);

    useEffect(() => {
        const handleStateChange = (ev: Event | CustomEvent) => {
            if ("detail" in ev) {
                setValue(ev.detail.payload || null);
                onStateChange?.(ev);
            }
        };

        const { current } = widgetRef;

        if (current) {
            current.addEventListener("statechange", handleStateChange);
            return () => current.removeEventListener("statechange", handleStateChange);
        } else {
            return () => null;
        }
    }, [onStateChange]);

    return (
        <altcha-widget
            data-testid='altcha'
            ref={widgetRef}
            style={{
                "--altcha-max-width": "100%",
                "--altcha-border-radius": "5px",
                "--altcha-color-base": "#1976d2",
                "--altcha-color-text": "#fff",
                // "--altcha-color-text": "#646465", #1565c0, #007bce, #1976d2
            }}
            challengeurl={config.DAC_SERVER_URL + "/altcha"}
            hidefooter={true}
            hidelogo={true}
            strings={JSON.stringify({
                arialLinkLabel: "",
                error: "La vérification a échoué",
                expired: "La vérification a expiré",
                footer: "",
                label: "Je ne suis pas un robot",
                verified: "Vérifié",
                verifying: "Vérification en cours",
                waitAlert: "Vérification, veuillez patienter",
            })}
            onverified={onVerified}></altcha-widget>
    );
});

export default Altcha;
